import {PaymentMethod, URLs, JoinModes} from "../common/constants";
import {translate} from '../i18n/translate.js';

//TODO Pass the new parameters
export function getPaymentMethodDescription(methodKey, staticData, pageContext, mode) {
    const buttonTitle = translate((pageContext == URLs.STORE) ? "Place Order" :
        (pageContext == URLs.JOIN) ? "Checkout" :
        (pageContext == URLs.PAY) ?  "Continue" : "Next");
    const isFarmSeasonal = staticData.isFarmSeasonal;
    const farmName = staticData.farmName;
    const preapprovalChargeLimit = Math.round(staticData.preapprovalChargeLimit);
    const preapprovalChargeLimitDollar = preapprovalChargeLimit < 0 ? ('-$' + Math.abs(preapprovalChargeLimit)) : ('$' + preapprovalChargeLimit);
    const farmPhone = staticData.farmPhone;
    if (pageContext == URLs.STORE && staticData.isChargeOnDelivery &&
        (methodKey == PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key || methodKey == PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key || methodKey == PaymentMethod.PAYPAL_PREAPPROVE.key)){
        return translate("ON_DELIVERY_CHARGE_noToken").replace("_BUTTON_TITLE_", buttonTitle);
    }
    switch (methodKey) {
        case PaymentMethod.AUTHORIZE_DOT_NET.key:
            return (pageContext == URLs.JOIN) ? translate("AUTHORIZE_DOT_NET_MESSAGE").replace("_BUTTON_TITLE_", buttonTitle) :
                translate("AUTHORIZE_DOT_NET_store").replace("_BUTTON_TITLE_", buttonTitle);
        case PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key:
            if (pageContext == URLs.JOIN && mode == JoinModes.ADD)
                return translate("AUTHORIZE_DOT_NET_PREAPPROVE_reuse").replace("_BUTTON_TITLE_", buttonTitle);
            return !isFarmSeasonal ? translate("MASSAGE.AUTHORIZE_DOT_NET_PREAPPROVE").replace("{0}", buttonTitle).replace("{1}", farmName).replace("{2}", preapprovalChargeLimitDollar) :
                translate("AUTHORIZE_DOT_NET_PREAPPROVE_seasonal").replace("{0}", buttonTitle);
        case PaymentMethod.CASH.key:
            return translate("MASSAGE.CASH").replace("{0}", buttonTitle);
        case PaymentMethod.CHECK.key:
            return (pageContext == URLs.JOIN && mode != JoinModes.ADD) ? translate("MASSAGE.CHECKS").replace("{0}", buttonTitle) :
                translate("MASSAGE.CHECK").replace("{0}", buttonTitle).replace("{1}", farmName)
        case PaymentMethod.ELECTRONIC_CHECK.key :
            return (pageContext == URLs.JOIN) ? translate("MASSAGE.ELECTRONIC_CHECK").replace("{0}", buttonTitle) :
                translate("MASSAGE.ELECTRONIC_CHECK_store").replace("{0}", buttonTitle);
        case PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key :
            if (pageContext == URLs.JOIN && mode == JoinModes.ADD)
                return translate("ELECTRONIC_CHECK_PREAPPROVE_reuse").replace("{0}", buttonTitle);
            return !isFarmSeasonal ? translate("MASSAGE.ELECTRONIC_CHECK_PREAPPROVE").replace("{1}", farmName).replace("{2}", preapprovalChargeLimitDollar) :
                translate("ELECTRONIC_CHECK_PREAPPROVE_seasonal").replace("{0}", buttonTitle);
        case PaymentMethod.PAYPAL_STANDARD.key:
            return (pageContext == URLs.JOIN) ? translate("MASSAGE.PAYPAL_STANDARD").replace("{0}", buttonTitle):
                translate("MASSAGE.PAYPAL_STANDARD_store").replace("{0}", buttonTitle);
        case PaymentMethod.PAYPAL_PREAPPROVE.key:
            if (pageContext == URLs.JOIN && mode == JoinModes.ADD)
                return translate("PAYPAL_PREAPPROVE_reuse").replace("{0}", buttonTitle);
            return !isFarmSeasonal ? translate("PAYPAL_PREAPPROVE_store").replace("{1}", farmName).replace("{0}", buttonTitle).replace("{2}", preapprovalChargeLimitDollar) :
                translate("PAYPAL_PREAPPROVE_seasonal").replace("{0}", buttonTitle);
        case PaymentMethod.PHONE.key:
            return (staticData.checkInstructions || staticData.checkInstructions.length > 0) ? staticData.checkInstructions :
                translate("MASSAGE.PHONE").replace("{1}", farmName).replace("{0}", buttonTitle).replace("{2}", farmPhone);
        case PaymentMethod.EBT_ONLINE.key:
            return translate("MASSAGE.EBT_ONLINE").replace("{0}", buttonTitle);
    }
}

//TODO Use for Add subscription / make payment / on-week-debit
//ELECTRONIC_CHECK Make Payment
// "Select this payment method to make a one-time payment. Once you click the \"<b>" + buttonTitle + "</b>\" button, we will direct you to a secure site to enter your payment information.";

//ON_DELIVERY_CHARGE + preapproval + store + hasToken
// "Once you click on the \"<b>" + buttonTitle + "</b>\" button, we will start processing your order. You will be charged after the delivery of your order takes place using the method of payment we have on file for you.";

//ON_DELIVERY_CHARGE + preapproval + store + noToken
// "You will be charged for your order after the delivery takes place. Once you click the \"<b>" + buttonTitle + "</b>\" button, you will be directed to a secure site to enter your payment information.";








// WEBPACK FOOTER //
// ./src/common/paymentMethodsData.js